angular.module("SupportAgent")
.directive("navNotification", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/nav-notification.html",
  scope: {
   title: "=",
   subtitle: "=",
   image: "="
  }
 };
})
.directive('placeholder', ['gettextCatalog', function (gettextCatalog) {
 return {
  restrict: 'A',
  link: function (scope, element, attrs) {
   var translatedPlaceholder = gettextCatalog.getString(attrs.placeholder);
   element.attr('placeholder', translatedPlaceholder);
  }
 };
}])
.directive("supportChat", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/support-chat.html"
 };
})
.directive("supportQueue", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/support-queue.html"
 };
})
.directive("supportTabs", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/support-tabs.html"
 };
})
.directive("tabApps", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-apps.html"
 };
})
.directive("tabCustomerInfo", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-customer-info.html"
 };
})
.directive("tabDiagnostics", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-diagnostics.html"
 };
})
.directive("tabRemoteControl", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-remote-control.html"
 };
})
.directive("tabRemoteSecurity", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-remote-security.html"
 };
})
.directive("tabDevice", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-device.html"
 };
})
.directive("tabMdm", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-mdm.html"
 };
})
.directive("tabCircle", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-circle.html"
  };
})
.directive("tabIdaHost", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-ida-host.html"
 };
})
.directive("tabIdaChart", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-ida-chart.html"
 };
})
 .directive("tabSpeedTest", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-speed-test.html"
 };
})
.directive('wifiConfiguration', function() {
  return {
    restrict: 'E',
    templateUrl: '/router-config/htdocs/templates/directives/wifi-configuration.html',
    controller:'routerConfigCtr'
  };
})
.directive('linearViewScreen', function() {
  return {
    restrict: 'E',
    templateUrl: '/h2g-linear-view/templates/linear-view-screen.html',
    controller:'TabCircleController'
  };
})
.directive("tabLocateDevice", function () {
 return {
  restrict: "E",
  templateUrl: "./snippets/directives/tab-locate-device.html"
 };
})
.directive('testHistory', function() {
  return {
    restrict: 'E',
    templateUrl: '/h2g-test-history/templates/test-history.html',
    controller:'TabCircleController'
  };
})
.directive('resultInfo', function() {
  return {
    restrict: 'E',
    templateUrl: '/h2g-test-results/templates/result-info.html'
  };
})
.directive('wifiSpectrum', function() {
  return {
    restrict: 'E',
    templateUrl: '/wifi-spectrum/templates/wifi-spectrum.html',
    controller:'wifiSpectrum'
  };
})
.directive('deviceDetails', function() {
  return {
    restrict: 'E',
    templateUrl: '/lan-scan/templates/device-details.html',
    controller:'TabCircleController'
  };
})
.directive('deviceList', function() {
  return {
    restrict: 'E',
    templateUrl: '/lan-scan/templates/device-list.html',
    controller:'localScanCtrl'
  };
})
.directive('onScrollEvent', function() {
    return {
        restrict: 'A',
        link: function($scope, $elm, $attrs) {
           $elm.bind("scroll", function(/*evt*/) {
              $scope.$apply(function() {
                $scope.$eval($attrs.onScrollEvent);
             });
            });
        }
    };
})
.directive('wifiSpectrumHelp', function() {
  return {
    restrict: 'E',
    templateUrl: '/wifi-spectrum/templates/wifi-spectrum-help.html',
    controller:'WifiSpectrumHelpCtrl'
  };
})
.directive('wifiSpectrumManualSelection', function() {
  return {
    restrict: 'E',
    templateUrl: '/wifi-spectrum/templates/wifi-spectrum-manual-selection.html',
    controller:'WifiSpectrumManualScreenCtrl'
  };
})
.directive('wtgValidator',function() {
 return {
  restrict: 'A',
  require: 'ngModel',
  scope: {wtgValidator:'<'},
  link: function(scope,elm,attr,model) {
   var wv = scope.wtgValidator;
   var n = wv.name||'wtgValidator';
   var fn = wv.validator||wv.fn||wv;
   model.$validators[n] = fn;
  }
 };
})
.directive('wtgAsyncValidator',function() {
 return {
  restrict: 'A',
  require: 'ngModel',
  scope: {wtgAsyncValidator:'<'},
  link: function(scope,elm,attr,model) {
   var wv = scope.wtgAsyncValidator;
   var n = wv.name||'wtgAsyncValidator';
   var fn = wv.validator||wv.fn||wv;
   model.$asyncValidators[n] = fn;
  }
 };
});
